// Necessary Import
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: #B63643;
    --secondary-color: #D97E8F;
    --accent-color: #FC889B;
    --background-color: #FAE6E8;
    --extra-color: #FAE5D4;
    --font-primary: 'Raleway', sans-serif;
    --font-secondary: 'Sacramento', cursive;
  }
`;

export default GlobalStyle;